import { isNil } from 'lodash';
import { ref } from 'vue';

export function useProgress() {
  const currentPerc = ref(0);
  const currentStepMessage = ref('');
  /** DOM `setInterval` id; typed for both DOM `number` and Node `Timer` from merged typings. */
  const progressInterval = ref<ReturnType<typeof setInterval> | null>(null);
  const shouldShowProgressDialog = ref(false);

  const createInterval = (message = '', max = 0, timeout = 750) => {
    clear();
    progressInterval.value = setInterval(() => {
      if (currentPerc.value < max) {
        // Cannot just increment the ref value - it doesn't actually update as you'd expect
        update(message, (currentPerc.value = currentPerc.value + 1));
      }
    }, timeout);
  };

  const zoom = (targetProgress = 0, timeout = 150) =>
    new Promise<void>(resolve => {
      const tick = () => {
        if (currentPerc.value >= targetProgress) {
          resolve();
          return;
        }
        currentPerc.value++;
        setTimeout(tick, timeout);
      };
      tick();
    });

  const update = (message = '', percentage = 0) => {
    currentStepMessage.value = message;
    currentPerc.value = percentage;
  };

  const clear = () => {
    if (!isNil(progressInterval.value)) {
      clearInterval(progressInterval.value);
      progressInterval.value = null;
    }
  };

  const setDialogVisibility = (shouldShow: boolean) => {
    shouldShowProgressDialog.value = shouldShow;
  };

  return {
    createInterval,
    zoom,
    update,
    clear,
    setDialogVisibility,
    shouldShowProgressDialog,
    currentStepMessage,
    currentPerc
  };
}
